var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2B2A35",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24 1A6.246 6.246 0 0 0 1 7.24v8.64a6.246 6.246 0 0 0 6.24 6.24h8.64a6.246 6.246 0 0 0 6.24-6.24V7.24A6.246 6.246 0 0 0 15.88 1H7.24Zm10.08 3.84c.528 0 .96.432.96.96s-.432.96-.96.96a.963.963 0 0 1-.96-.96c0-.528.432-.96.96-.96Zm-5.76 1.44a5.283 5.283 0 0 1 5.28 5.28 5.283 5.283 0 0 1-5.28 5.28 5.283 5.283 0 0 1-5.28-5.28 5.283 5.283 0 0 1 5.28-5.28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 3.5
  }))));
};
export default SvgInstagram;